import { observer } from 'mobx-react';
import { Link } from '../../../Resource/Types';
import { useTranslationsContext } from '../../../Translations/UseTranslationsContext';
import WhenLink from '../../../WhenLink';
import Image from '../../Image';
import * as style from '../style.module.css';

interface Props {
  links: ReadonlyArray<Link>;
}

function UniversityLogoOnWhite({ links }: Props) {
  const { translate } = useTranslationsContext();
  return (
    <WhenLink rel="logo-on-white" links={links}>
      {({ href }) => (
        <Image
          src={href}
          alt={translate('University partner logo')}
          className={style.universityLogo}
          data-test-university-logo={true}
          tabIndex={0}
          aria-label={translate('University partner logo')}
        />
      )}
    </WhenLink>
  );
}

export default observer(UniversityLogoOnWhite);
